export default __webpack_public_path__ + "static/media/Directors' Certificate to Mr Johnny G De Leon (Cubao Branch).3885b541.pdf";